const prefix = 'nxt';
const iconName = 'present';
const width = 1024;
const height = 1024;
const ligatures = [];
const unicode = '';
const svgPathData =
  'M1024.001 84.867h-1024v854.264h1024v-854.264zM930.911 845.163h-837.819v-666.326h837.819v666.326zM418.907 512h-93.089l186.186-189.837 186.181 189.837h-93.090v189.835h-186.187v-189.835z';

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtPresent = definition;

export { definition, nxtPresent, prefix, iconName, width, height, ligatures, unicode, svgPathData };
